import { Model } from './Models'
import {
  ActionType,
  createReducer,
  createStandardAction
} from 'typesafe-actions'

export interface CategorySelectionState {
  model: Model
  income: number
  year: number
}

export const selectorActions = {
  selector: {
    model: {
      set: createStandardAction('SELECTOR/MODEL/SET')<string>()
    },
    income: {
      set: createStandardAction('SELECTOR/INCOME/SET')<string>()
    },
    year: {
      set: createStandardAction('SELECTOR/YEAR/SET')<string>()
    }
  }
}

export const categorySelection = createReducer<
  CategorySelectionState,
  ActionType<typeof selectorActions>
>({
  model: Model.MARRIED_WITH_CHILDREN_AND_DUAL_INCOME,
  income: 150000,
  year: 2018
})
  .handleAction(selectorActions.selector.income.set, (state, { payload }) => ({
    ...state,
    income: parseInt(payload, 10)
  }))
  .handleAction(selectorActions.selector.model.set, (state, { payload }) => ({
    ...state,
    model: payload as Model
  }))
  .handleAction(selectorActions.selector.year.set, (state, { payload }) => ({
    ...state,
    year: parseInt(payload, 10)
  }))

export const setBrackets = createStandardAction('BRACKETS/SET')<number[]>()

export const brackets = createReducer<number[], ActionType<typeof setBrackets>>(
  []
).handleAction(setBrackets, (state, { payload }) => payload)
